export const AI_FORMULA =
  "How might we VERB OUTCOME without CONSTRAINTS based on SOURCES";
